/* app/js/nav-search.js — live search in the left navigation.
 *
 * Type "land" and every menu entry and plugin that mentions it appears under the box: by name first, then by
 * group and description (so "land" finds Landing-page reports too). Enter or a click opens it. Arrow keys move,
 * Esc clears. "/" or Ctrl/⌘+K from anywhere jumps into the box (and opens the menu on a phone).
 *
 * What it searches is what the menu actually holds right now — the core reports and every plugin the menu shows
 * for this site (interactions.js puts them there) — plus the descriptions from GET /plugins, and plugins that are
 * available but switched off for this site (shown as "Off — open Marketplace"). No new API, nothing stored.
 * Injected by script so the shared sidebar.php stays untouched. Strings EN + NL live here (like app-sites.js).
 */
(function () {
  'use strict';
  var STR = {
    en: { ph: 'Search reports & plugins', none: 'Nothing matches “%q%”.', off: 'Off for this site — open Marketplace', hint: 'Press / to search',
          label: 'Search the menu' },
    nl: { ph: 'Zoek rapporten & plugins', none: 'Niets gevonden voor “%q%”.', off: 'Uit voor deze site — open Marketplace', hint: 'Druk / om te zoeken',
          label: 'Zoek in het menu' }
  };
  function L() { return STR[(window.GS && GS.locale === 'nl') ? 'nl' : 'en']; }
  function S(k, v) { var s = L()[k] || STR.en[k] || k; if (v) for (var x in v) s = s.split('%' + x + '%').join(v[x]); return s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /** lower-case, accents off: "Géo" and "geo" match */
  function norm(s) { s = String(s || '').toLowerCase(); try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {} return s; }

  var box, input, list, items = [], sel = -1, plugins = null, pluginsFor = null;

  function css() {
    if (document.querySelector('style[data-nav-search]')) return;
    var st = document.createElement('style'); st.setAttribute('data-nav-search', '');
    st.textContent =
      '.gs-ns{position:relative;margin:0 0 10px}' +
      '.gs-ns-in{width:100%;height:34px;border:1px solid var(--line-2,#D0D4DA);border-radius:8px;background:var(--card,#fff);' +
        'padding:0 30px 0 32px;font-size:13px;color:var(--ink,#1B2330);outline:none}' +
      '.gs-ns-in:focus{border-color:var(--accent,#1FA463);box-shadow:0 0 0 3px rgba(31,164,99,.14)}' +
      '.gs-ns-ic{position:absolute;left:10px;top:9px;width:15px;height:15px;color:var(--muted,#8C95A1);pointer-events:none}' +
      '.gs-ns-k{position:absolute;right:8px;top:8px;font-size:11px;line-height:16px;padding:0 5px;border:1px solid var(--line-2,#D0D4DA);' +
        'border-radius:4px;color:var(--muted,#8C95A1);pointer-events:none}' +
      '.gs-ns-in:focus~.gs-ns-k,.gs-ns.has-q .gs-ns-k{display:none}' +
      '.gs-ns-list{margin-top:6px;display:flex;flex-direction:column;gap:2px}' +
      '.gs-ns-list[hidden]{display:none}' +
      '.gs-ns-r{display:flex;gap:9px;align-items:flex-start;padding:7px 8px;border-radius:8px;text-decoration:none;color:var(--ink,#1B2330);min-width:0}' +
      '.gs-ns-r:hover,.gs-ns-r.on{background:var(--accent-soft,#E7F5EC);color:var(--ink,#1B2330)}' +
      '.gs-ns-r i{font-size:15px;line-height:18px;color:var(--accent-2,#178A52);flex:none}' +
      '.gs-ns-t{min-width:0;flex:1}' +
      '.gs-ns-n{font-size:13px;font-weight:600;line-height:18px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.gs-ns-s{font-size:11.5px;line-height:15px;color:var(--muted,#8C95A1);overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
      '.gs-ns-r.off .gs-ns-n{color:var(--ink-2,#4A5568);font-weight:500}' +
      '.gs-ns mark{background:rgba(245,158,11,.28);color:inherit;padding:0;border-radius:2px}' +
      '.gs-ns-none{font-size:12.5px;color:var(--muted,#8C95A1);padding:6px 8px}';
    (document.head || document.documentElement).appendChild(st);
  }

  function mount() {
    if (box) return true;
    var body = document.querySelector('.gs-nav .gs-nav-body'); if (!body) return false;
    css();
    box = document.createElement('div'); box.className = 'gs-ns'; box.setAttribute('role', 'search');
    box.innerHTML =
      '<svg class="gs-ns-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      '<input class="gs-ns-in" type="search" autocomplete="off" spellcheck="false" aria-autocomplete="list" aria-controls="gsNsList" aria-expanded="false">' +
      '<span class="gs-ns-k" aria-hidden="true">/</span>' +
      '<div class="gs-ns-list" id="gsNsList" role="listbox" hidden></div>';
    body.insertBefore(box, body.firstChild);
    input = box.querySelector('.gs-ns-in'); list = box.querySelector('.gs-ns-list');
    input.placeholder = S('ph'); input.setAttribute('aria-label', S('label'));
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { loadPlugins(); if (input.value) run(); });
    input.addEventListener('keydown', key);
    return true;
  }

  /* ---- what can be found ---- */
  function currentSiteId() {
    var a = (window.GS && GS.sites) || [];
    var x = a.filter(function (s) { return s.public_key === GS.site; })[0] || a[0];
    return x ? x.id : 0;
  }
  function loadPlugins() {
    var id = currentSiteId();
    if (!window.GS || !GS.api || pluginsFor === id) return;
    pluginsFor = id;
    GS.api('/plugins' + (id ? '?site_id=' + id : '')).then(function (r) {
      plugins = (r && r.ok && r.data && r.data.plugins) || [];
      if (input && input.value) run();
    }).catch(function () {});
  }
  function groupOf(a) {
    var g = a.closest('.gs-nav-group'); if (!g) return '';
    var h = g.querySelector('.gs-nav-head span'); return h ? h.textContent.trim() : '';
  }
  /** Everything the menu shows now, plus plugins that are available but off for this site. */
  function index() {
    var out = [], seen = {};
    document.querySelectorAll('.gs-nav a.gs-nav-link[href]').forEach(function (a) {
      if (a.closest('.gs-ns') || a.closest('[hidden]') || a.classList.contains('d-none')) return;
      var href = a.getAttribute('href'); if (!href || href === '#' || seen[href]) return;
      var name = (a.querySelector('span') || a).textContent.trim(); if (!name) return;
      var ic = a.querySelector('i.bi'); seen[href] = 1;
      out.push({ href: href, name: name, group: groupOf(a), icon: ic ? ic.className.replace(/\s+/g, ' ') : 'bi bi-dot',
                 ext: a.target === '_blank', desc: '' });
    });
    (plugins || []).forEach(function (p) {
      if (!p || !p.slug || p.slug === 'icon-library' || p.slug === 'example-hello') return;
      var href = '/' + p.slug, row = null;
      for (var i = 0; i < out.length; i++) if (out[i].href === href) { row = out[i]; break; }
      if (row) { row.desc = p.description || ''; return; }
      if (p.enabled === false) out.push({ href: '/plugins#' + p.slug, name: p.name || p.slug, group: S('off'), off: true,
                                          icon: 'bi ' + (p.icon_bi || 'bi-puzzle'), desc: p.description || '' });
    });
    return out;
  }

  /* ---- matching ---- */
  function score(it, q) {
    var n = norm(it.name), g = norm(it.group), d = norm(it.desc), s;
    if (n === q) s = 100;
    else if (n.indexOf(q) === 0) s = 90;
    else if ((' ' + n).indexOf(' ' + q) > -1) s = 80;           // start of a word in the name
    else if (n.indexOf(q) > -1) s = 70;
    else if (g.indexOf(q) > -1) s = 50;
    else if ((' ' + d).indexOf(' ' + q) > -1) s = 40;
    else if (d.indexOf(q) > -1) s = 30;
    else return 0;
    return it.off ? s - 25 : s;                                 // switched-off plugins after the ones you can open
  }
  /** `text` with the first match of `q` marked (accent-insensitive, so the mark lines up with norm()). */
  function mark(text, q) {
    var t = String(text || ''), i = norm(t).indexOf(q);
    if (i < 0 || !q) return esc(t);
    return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + q.length)) + '</mark>' + esc(t.slice(i + q.length));
  }
  /** a short piece of the description around the match */
  function snippet(d, q) {
    var i = norm(d).indexOf(q); if (i < 0) return '';
    var a = Math.max(0, i - 28), b = Math.min(d.length, i + q.length + 60);
    return (a > 0 ? '…' : '') + mark(d.slice(a, b), q) + (b < d.length ? '…' : '');
  }

  function run() {
    var raw = input.value.trim(), q = norm(raw);
    box.classList.toggle('has-q', !!raw);
    if (!q) { close(); return; }
    loadPlugins();
    items = index().map(function (it) { return { it: it, s: score(it, q) }; })
      .filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s || a.it.name.localeCompare(b.it.name); })
      .slice(0, 10).map(function (x) { return x.it; });
    sel = items.length ? 0 : -1;
    if (!items.length) {
      list.innerHTML = '<div class="gs-ns-none">' + esc(S('none', { q: raw })) + '</div>';
    } else {
      list.innerHTML = items.map(function (it, i) {
        var inName = norm(it.name).indexOf(q) > -1;
        var sub = it.group ? esc(it.group) : '';
        if (!inName && it.desc) { var sn = snippet(it.desc, q); if (sn) sub = (sub ? sub + ' · ' : '') + sn; }
        else if (!inName && norm(it.group).indexOf(q) > -1) sub = mark(it.group, q);
        return '<a class="gs-ns-r' + (i === 0 ? ' on' : '') + (it.off ? ' off' : '') + '" role="option" id="gsNsR' + i + '" href="' + esc(it.href) + '"' +
          (it.ext ? ' target="_blank" rel="noopener"' : '') + ' aria-selected="' + (i === 0) + '">' +
          '<i class="' + esc(it.icon) + '" aria-hidden="true"></i><span class="gs-ns-t"><span class="gs-ns-n">' + mark(it.name, q) + '</span>' +
          (sub ? '<span class="gs-ns-s">' + sub + '</span>' : '') + '</span></a>';
      }).join('');
    }
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-activedescendant', sel >= 0 ? 'gsNsR' + sel : '');
  }
  function close() {
    if (!list) return;
    list.hidden = true; list.innerHTML = ''; items = []; sel = -1;
    input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant');
  }
  function move(d) {
    if (!items.length) return;
    sel = (sel + d + items.length) % items.length;
    list.querySelectorAll('.gs-ns-r').forEach(function (a, i) { a.classList.toggle('on', i === sel); a.setAttribute('aria-selected', i === sel); });
    var on = list.querySelector('.gs-ns-r.on'); if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest' });
    input.setAttribute('aria-activedescendant', 'gsNsR' + sel);
  }
  function key(e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
    else if (e.key === 'Enter') {
      var it = items[sel]; if (!it) return; e.preventDefault();
      if (it.ext) window.open(it.href, '_blank', 'noopener'); else location.assign(it.href);
    } else if (e.key === 'Escape') {
      if (input.value) { input.value = ''; box.classList.remove('has-q'); close(); } else input.blur();
    }
  }

  /* "/" or Ctrl/⌘+K: jump into the box from anywhere (not while typing somewhere else). */
  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    var typing = /^(input|textarea|select)$/i.test((e.target && e.target.tagName) || '') || (e.target && e.target.isContentEditable);
    var slash = k === '/' && !typing && !e.ctrlKey && !e.metaKey && !e.altKey;
    var cmdK = k === 'k' && (e.ctrlKey || e.metaKey) && !e.altKey;
    if (!slash && !cmdK) return;
    if (!mount()) return;
    e.preventDefault();
    var nav = document.getElementById('gsNav');
    if (!input.offsetParent && nav && window.bootstrap && bootstrap.Offcanvas) {      // phone: the menu is an offcanvas
      var oc = bootstrap.Offcanvas.getOrCreateInstance(nav);
      nav.addEventListener('shown.bs.offcanvas', function f() { nav.removeEventListener('shown.bs.offcanvas', f); input.focus(); });
      oc.show();
    } else { input.focus(); input.select(); }
  });

  if (document.readyState !== 'loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('gs:site-change', function () { pluginsFor = null; plugins = null; if (input && input.value) { loadPlugins(); run(); } });
})();
